import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';

@Injectable()
export class UserNotificationService {

    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/notifications/user";

    async create(notificationList,_id:string) {
        return await this.httpClient.post(`${this.endPoint}/${_id}`, notificationList);
    }

    async update(notificationList){
        let id = notificationList.user.username;

        return await this.httpClient.update(this.endPoint,id,notificationList);
    }

    async get(_id:string){
        return await this.httpClient.get(`${this.endPoint}/${_id}`)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user-notification.service.ts